"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M3.26 19.282c-.626 0-1.159-.22-1.6-.66a2.18 2.18 0 0 1-.66-1.6V5.247c0-.625.22-1.158.66-1.599.441-.44.974-.66 1.6-.66h15.75c.625 0 1.158.22 1.598.66.44.44.66.974.66 1.6V8.45a2.667 2.667 0 0 1-2.666 2.667H3.26v5.906h8.713c.317 0 .585.109.803.327.218.218.327.485.327.803 0 .317-.109.584-.327.802a1.091 1.091 0 0 1-.803.327H3.26Zm0-12.138h15.75V5.246H3.26v1.898Zm14.798 10.973h-1.874a.99.99 0 0 1-.729-.294.989.989 0 0 1-.294-.729.99.99 0 0 1 .294-.729.989.989 0 0 1 .729-.294h1.873v-1.874a.99.99 0 0 1 .294-.728.99.99 0 0 1 .729-.295.99.99 0 0 1 .729.295.99.99 0 0 1 .294.728v1.874h1.874a.99.99 0 0 1 .729.294.989.989 0 0 1 .294.729.99.99 0 0 1-.294.729.99.99 0 0 1-.729.294h-1.874v1.874a.99.99 0 0 1-.294.729.989.989 0 0 1-.728.294.99.99 0 0 1-.729-.294.989.989 0 0 1-.294-.73v-1.873Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};